<template>
  <modal :show.sync="show" id="updateallvalues" size="xl" @close="onClose">
    <template slot="header">
      <h5 class="modal-title" id="exampleModalLabel">
        <slot name="title">
          Atualizar Informações da Região
        </slot>
      </h5>
    </template>

    <validation-observer v-if="show" ref="observer">
      <region-form :region.sync="otherRegion" />
    </validation-observer>

    <template slot="footer">
      <base-button type="secondary" @click="onClose">Fechar</base-button>
      <base-button type="success"   @click="onSave" :loading="isSaving">Salvar</base-button>
    </template>
  </modal>
</template>

<script setup>
import RegionForm from './RegionForm.vue';
import { ref, defineProps, defineEmits, watch } from 'vue';

const props = defineProps({
  show: Boolean,
  region: Object,
  isSaving: { Boolean, default: false },
});

const emit = defineEmits(['save', 'update:show', 'update:region']);
const observer = ref(null);

const otherRegion = ref({ ...props.region });

watch(
  () => props.region,
  (newRegion) => {
      otherRegion.value = { 
      ...newRegion, 
      branch_id: otherRegion.value.branch_id || newRegion.branch_id 
    };
  },
  { deep: true, immediate: true }
);

watch(
  otherRegion,
  (newOtherRegion) => {
    emit('update:region', { ...newOtherRegion });
  },
  { deep: true }
);

const onClose = () => {
  if (observer.value) {
    observer.value.reset();
  }
  emit('update:show', false);
};

const onSave = async () => {
  if (props.isSaving) return;

  const isValid = await observer.value.validate();
  if (!isValid) return;

  emit('save', { ...otherRegion.value });
};
</script>
